import React, { useState, useEffect,useRef } from 'react';
import './header.scss';


const Notification: React.FC = () => {
    const [isShow, setIsShow] = useState<boolean>(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsShow(true);
        }, 100);
    
        return () => clearTimeout(timer); // Cleanup to prevent memory leaks
      }, []);
    
    
    return (
        <>
            <div className={`dropdown-menu pop-notification ${isShow ?'show':''}`}>
                <div className="p-v-15 p-h-25 border-bottom d-flex justify-content-between align-items-center">
                    <p className="text-dark font-weight-semibold m-b-0">
                        <i className="anticon anticon-bell"></i>
                        <span className="m-l-10">Notification</span>
                    </p>
                    <a className="btn-sm btn-default btn" href="javascript:void(0);">
                        <small>View All</small>
                    </a>
                </div>
                <div className="relative">
                    <div className="overflow-y-auto relative scrollable" style={{ maxHeight: '300px' }}>
                        <a href="javascript:void(0);" className="dropdown-item d-block p-15 border-bottom">
                            <div className="d-flex">
                                <div className="avatar avatar-blue avatar-icon">
                                    <i className="anticon anticon-mail"></i>
                                </div>
                                <div className="m-l-15">
                                    <p className="m-b-0 text-dark">You received a new message</p>
                                    <p className="m-b-0"><small>8 min ago</small></p>
                                </div>
                            </div>
                        </a>
                        <a href="javascript:void(0);" className="dropdown-item d-block p-15 border-bottom">
                            <div className="d-flex">
                                <div className="avatar avatar-cyan avatar-icon">
                                    <i className="anticon anticon-user-add"></i>
                                </div>
                                <div className="m-l-15">
                                    <p className="m-b-0 text-dark">New user registered</p>
                                    <p className="m-b-0"><small>7 hours ago</small></p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Notification;